var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train-ko",class:[_vm.ki ? 'down-box' : 'up-box']},[_c('Train',{attrs:{"tr":_vm.train.tr,"ik":_vm.ik,"sy":_vm.train.sy,"ki":_vm.ki,"unyo":_vm.unyo,"vehicle":_vm.vehicle,"bg-style":_vm.style,"line":"KO"}}),(_vm.train.dl)?_c('div',{staticClass:"delay",style:({
      order: _vm.ki ? -1 : 1
    })},[_vm._v(" + "+_vm._s(_vm.train.dl)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }